import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const CopyIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 10C6 8.1144 6 7.1716 6.58579 6.58579C7.1716 6 8.1144 6 10 6H10.6667C12.5523 6 13.4951 6 14.0809 6.58579C14.6667 7.1716 14.6667 8.1144 14.6667 10V10.6667C14.6667 12.5523 14.6667 13.4951 14.0809 14.0809C13.4951 14.6667 12.5523 14.6667 10.6667 14.6667H10C8.1144 14.6667 7.1716 14.6667 6.58579 14.0809C6 13.4951 6 12.5523 6 10.6667V10Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3332 6.00004C11.3316 4.02865 11.3018 3.00751 10.728 2.30833C10.6172 2.1733 10.4934 2.04949 10.3584 1.93868C9.62078 1.33337 8.52498 1.33337 6.33331 1.33337C4.14166 1.33337 3.04583 1.33337 2.30827 1.93868C2.17324 2.04949 2.04943 2.1733 1.93862 2.30833C1.33331 3.04589 1.33331 4.14172 1.33331 6.33337C1.33331 8.52504 1.33331 9.62084 1.93862 10.3584C2.04943 10.4934 2.17324 10.6172 2.30827 10.728C3.00745 11.3019 4.02859 11.3317 5.99998 11.3333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
